<p-card styleClass="detail-card">
  <div class="section-header">
    <div>
      <h3>Sans créneau</h3>
      <p>
        {{ filteredPoolAffairsWithoutSlots.length }} /
        {{ poolAffairsWithoutSlots.length }} affaire{{
          poolAffairsWithoutSlots.length > 1 ? 's' : ''
        }}
        sans tournée proposée
      </p>
    </div>
  </div>

  @if (poolAffairsWithoutSlots.length > 0) {
    <div class="search-bar">
      <span class="p-input-icon-left" style="width: 100%">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          [ngModel]="poolSearchQuery"
          (ngModelChange)="poolSearchQueryChange.emit($event)"
          placeholder="Rechercher (affaire, ville…)"
          style="width: 100%"
        />
      </span>
    </div>
    <div class="tour-affairs-list">
      @for (affair of filteredPoolAffairsWithoutSlots; track affair.affairId) {
        <button
          type="button"
          class="tour-affair-item no-slot-item"
          [class.highlighted]="selectedNoSlotAffairId === affair.affairId"
          (click)="noSlotAffairSelected.emit(affair)"
        >
          <div class="item-topline">
            <span class="affair-name">{{ affair.affairName }}</span>
            @if (affair.source === 'manual') {
              <button
                type="button"
                class="manual-delete-btn"
                (click)="
                  $event.stopPropagation(); manualDeleteRequested.emit(affair)
                "
                pTooltip="Supprimer cette affaire manuelle"
                tooltipPosition="left"
                aria-label="Supprimer cette affaire manuelle"
              >
                <i class="pi pi-trash"></i>
              </button>
            }
          </div>
          <div class="item-meta">
            <div class="item-address">
              <i class="pi pi-map-marker"></i>
              <span>{{ affair.postalCode }} {{ affair.locality }}</span>
              @if (affair.postalCode || affair.locality) {
                <button
                  type="button"
                  class="address-copy-btn"
                  [class.copied]="copiedAddressAffairId === affair.affairId"
                  (click)="
                    addressCopied.emit({ affair: affair, event: $event })
                  "
                  [pTooltip]="
                    copiedAddressAffairId === affair.affairId
                      ? 'Copié'
                      : 'Copier CP + ville'
                  "
                  tooltipPosition="top"
                  aria-label="Copier le code postal et la ville"
                >
                  <i
                    class="pi"
                    [class.pi-copy]="copiedAddressAffairId !== affair.affairId"
                    [class.pi-check]="copiedAddressAffairId === affair.affairId"
                  ></i>
                </button>
              }
            </div>
            @if (affair.last_call_reason_type) {
              <div class="item-call-reason">
                <i class="pi pi-phone"></i>
                <span class="call-reason-type">{{
                  affair.last_call_reason_type
                }}</span>
              </div>
            }
            @if (affair.last_call_reason_comment) {
              <div class="item-call-comment">
                <i class="pi pi-comment"></i>
                <span>{{ affair.last_call_reason_comment }}</span>
              </div>
            }
          </div>
        </button>
      }
      @if (filteredPoolAffairsWithoutSlots.length === 0 && poolSearchQuery) {
        <div class="empty-panel">
          <i class="pi pi-search"></i>
          <p>Aucun résultat pour « {{ poolSearchQuery }} »</p>
        </div>
      }
    </div>
  } @else {
    <div class="empty-panel">
      <i class="pi pi-check-circle"></i>
      <p>Toutes les affaires du vivier ont au moins un créneau proposé.</p>
    </div>
  }
</p-card>
